import { CampaignCreateDto, CampaignUpdateDto, Pagination, PaginationQuery } from '@libs/dto';
import { Campaign } from '@libs/models';

import { api } from '../common.api';

export const campaignApi = api.injectEndpoints({
  endpoints: (build) => ({
    campaignCreate: build.mutation<Campaign, CampaignCreateDto>({
      query: (body) => ({
        url: '/campaign',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Campaign'],
    }),
    campaignUpdate: build.mutation<Campaign, CampaignUpdateDto>({
      query: (body) => ({
        url: `/campaign/${body.id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Campaign'],
    }),
    campaignIndex: build.query<Pagination<Campaign>, { page?: number; limit?: number }>({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: '/campaign',
        method: 'GET',
        params: { page, limit },
      }),
      providesTags: ['Campaign'],
    }),
    campaignSearch: build.query<Pagination<Campaign>, PaginationQuery>({
      query: ({ q, page = 1, limit = 10 }) => ({
        url: '/campaign/search',
        method: 'GET',
        params: { q, page, limit },
      }),
      providesTags: ['Campaign'],
    }),
    campaignView: build.query<Campaign, number>({
      query: (id) => ({
        url: `/campaign/${id}`,
        method: 'GET',
      }),
      providesTags: ['Campaign'],
    }),
    campaignFindByPost: build.query<Pagination<Campaign>, { postId: number; page?: number; limit?: number }>({
      query: ({ postId, page = 1, limit = 10 }) => ({
        url: `/campaign/post/${postId}`,
        method: 'GET',
        params: { page, limit },
      }),
      providesTags: ['Campaign'],
    }),
    campaignDelete: build.mutation<Campaign, number>({
      query: (id) => ({
        url: `/campaign/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Campaign'],
    }),
  }),
});

export const {
  useCampaignCreateMutation,
  useCampaignUpdateMutation,
  useCampaignIndexQuery,
  useCampaignSearchQuery,
  useLazyCampaignSearchQuery,
  useCampaignViewQuery,
  useCampaignFindByPostQuery,
  useCampaignDeleteMutation,
} = campaignApi;
